import { withQuery } from 'ufo'

export default defineNuxtPlugin(async (nuxt) => {
  addRouteMiddleware('01.loginHash', async (to) => {
    const { login } = useUserSession()

    if (to.query.loginHash) {
      const response = await $ssoFetch(`/login/complete/${to.query.loginHash}`, {
        method: 'POST',
      })

      if (response.data.accessToken) {
        const _returnUrl = response.data.returnUrl
        if (_returnUrl) {
          return nuxt.runWithContext(() => navigateTo(
            withQuery(_returnUrl, { accessToken: response.data.accessToken.token }),
            {
              external: true,
            },
          ))
        }
        await nuxt.runWithContext(async () => await login(response.data.accessToken.token))
        return nuxt.runWithContext(() => navigateTo({ name: 'dashboard.profile' }))
      }

      return nuxt.runWithContext(() => navigateTo({
        name: 'registration',
        query: {
          token: response.data.signupToken,
          returnUrl: '',
        },
      }))
    }
  }, {
    global: true,
  })
})
